import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  align-items: center;
  column-gap: ${fluid(12, 16)};
  color: ${brand.global.white};

  &[data-theme='dark'] {
    color: ${brand.global.black};
  }
`;
const SocialLink = styled.a `
  color: inherit;

  svg {
    width: ${fluid(16, 24)};
    height: ${fluid(16, 24)};
  }
`;
export const SocialMediaLinksStyles = {
    Container,
    SocialLink,
};
